import script from "./header.vue?vue&type=script&setup=true&lang=js"
export * from "./header.vue?vue&type=script&setup=true&lang=js"

import "./header.vue?vue&type=style&index=0&id=4f8916ef&lang=scss&scoped=true"
import "./header.vue?vue&type=style&index=1&id=4f8916ef&scoped=true&lang=css"

import exportComponent from "D:\\Leo\\Frontend\\surveys\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4f8916ef"]])

export default __exports__